module.exports = __webpack_public_path__ + "static/images/concierge.7f203cd12e5891349485143a35289e9b.svg";